import React from 'react';
import Icon from '../../../components/AppIcon';

const ExecutiveSummaryCard = ({ 
  title, 
  value, 
  subtitle, 
  icon, 
  trend, 
  status, 
  onClick, 
  isEditable = false,
  teaserEditField,
  onStartEdit,
  onTeaserInput 
}) => {
  const getStatusStyles = () => {
    switch (status) {
      case 'compliant':
        return {
          bg: 'bg-success/10',
          text: 'text-success',
          border: 'border-success/20'
        };
      case 'warning':
        return {
          bg: 'bg-warning/10',
          text: 'text-warning',
          border: 'border-warning/20'
        };
      case 'critical':
        return {
          bg: 'bg-error/10',
          text: 'text-error',
          border: 'border-error/20'
        };
      default:
        return {
          bg: 'bg-muted',
          text: 'text-foreground',
          border: 'border-border'
        };
    }
  };

  const getTrendIcon = () => {
    if (trend === 'up') return 'TrendingUp';
    if (trend === 'down') return 'TrendingDown';
    return 'Minus';
  };

  const getTrendColor = () => {
    if (trend === 'up') return 'var(--color-success)';
    if (trend === 'down') return 'var(--color-error)';
    return 'var(--color-muted-foreground)';
  };

  const styles = getStatusStyles();

  return (
    <div 
      className={`bg-card border ${styles?.border} rounded-lg p-6 transition-smooth hover:shadow-lg cursor-pointer hover-lift relative group`}
      onClick={onClick}
    >
      {isEditable && (
        <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="bg-primary/10 p-1.5 rounded">
            <Icon name="Edit2" size={14} color="var(--color-primary)" />
          </div>
        </div>
      )}
      <div className="flex items-start justify-between mb-3">
        <div className={`${styles?.bg} ${styles?.text} p-3 rounded-md`}>
          <Icon name={icon} size={24} color="currentColor" />
        </div>
        {trend && (
          <div className="flex items-center gap-1">
            <Icon name={getTrendIcon()} size={18} color={getTrendColor()} />
          </div>
        )}
      </div>
      <h3 
        className="text-sm text-muted-foreground mb-2"
        contentEditable={isEditable && teaserEditField === `card-title-${title}`}
        suppressContentEditableWarning={true}
        onInput={(e) => onTeaserInput?.(e, `card-title-${title}`)}
        onClick={(e) => {
          if (isEditable) {
            e?.stopPropagation();
            onStartEdit?.(`card-title-${title}`, title);
          }
        }}
      >
        {title}
      </h3>
      <div className="flex items-baseline gap-2 mb-1">
        <span className={`text-3xl md:text-4xl font-bold ${styles?.text}`}>
          {value}
        </span>
      </div>
      {subtitle && (
        <p className="text-xs text-muted-foreground">{subtitle}</p>
      )}
    </div>
  );
};

export default ExecutiveSummaryCard;